import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./element-variables.scss";
Vue.use(ElementUI);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import SlideVerify from "vue-monoplasty-slide-verify";
Vue.use(SlideVerify);

const messages = {
  zh,
  en,
};

const en = {
  productservice: {
    product: "PRODUCTS & SERVICES",
    people: "High-end Talents Recruitment",
    forclient:
      "Scouring and recruiting top talents for clients, including undergraduate, master's, and PhD candidates from UK universities and colleges.",
    gongwu: "Tailor-made Comprehensive Business Visits",
    school: "Summer Camps in Junior and Senior Schools",
    corporation:
      "Collaborating with renowned junior and senior schools in the UK, we provide various summer school programs and camps in the UK.",
    onoffline: "Online and Offline Job Fairs",
    zhanlue: "Strategic Partners",
  },
  aboutus: {
    info1:
      "Dedicated to connecting top talents from China and the UK.",
    info2:"As a comprehensive talent platform based in the UK and expanding globally, UC-Elink focuses on providing professional and efficient career planning consulting and recommending services for global top talents.",
    info3:"The core team of UC-Elink has more than 10 years of experience in human resources industry, talent selection and recruitment, media experience and 20 years of experience in enterprise management.",
    info4:"All members have backgrounds in renowned companies and overseas studies, deeply understand the characteristics of overseas talent groups,and have unique insights into the needs of enterprises for overseas talents.",
    info5:"We are willing to work together with Chinese and British talents to meet the opportunities and challenges brought by the globalisation process, and to help outstanding talents to realise their dreams of globalisation in their career development.",
    ourservice: "Our Services",
    ourserviceinfo:
      "We have a large number of high-end corporate clients in both China and the UK, a network covering all universities in the UK, and experience in organizing large-scale online and offline recruitment events and business inspections.",
    ourservice1: "High-end Talents Recruitment",
    ourservice2:
      "Scouring and recruiting top talents for clients, including undergraduate, master’s, and PhD candidates from UK universities and colleges.",
    ourservice3: "Tailor-made Comprehensive Business Visits",
    ourservice4: "Summer Camps in Junior and Senior Schools",
    ourservice5:
      "Collaborating with renowned junior and senior schools in the UK, we provide various summer school programs and camps in the UK.",
    ourservice6: "Online and Offline Job Fairs",
    founder1: "About the Founder",
    founder2: "Kevin Qian",
    founder3: "China Europe International Business School (CEIBS) EMBA",
    founder4:
      "Vice President of China Europe Human Resources Research Association",
    founder5: "Previous Positions",
    founder6: "General Manager of HRoot",
    founder7: "Founder of vTradex",
    founder8: "General Manager of PDP China",
    founder9: "National Sales Director of NetEase",
    contactinfo1: "Connecting top talents in China and the United Kingdom",
    contactinfo2: "Contact us for an exclusive career planning consultation!",
    contactinfo3: "Contact Us",
    contactinfo4: "Strategic Partners",
    common1: "Privacy Policy",
    common2: "Contact Us",
    common3: "About Us",
    common4: "All rights reserved",
    team:
      "Our core team has over ten years of experience in the human resources industry, talent recruitment, media, and two decades of experience in corporate management.",
    client:
      "Large number of high-end corporate clients in both China and the United Kingdom",
    network: "Extensive network with universities across the United Kingdom",
    onoffline:
      "Abundant experience of organizing large-scale recruitment events and business visits both online and offline",
  },
  consultant: {
    zhitongche: "Career Express - Helping you get your dream job",
    zhitongche1:
      "Tailor-made personalized job search solutions to significantly increase the success rate of employment",
    zhitongche2: "You can bring your Resume to the consultant for more details",
    industry: "Select the industry you are interested in",
    industry1:
      "We will help you sort out your personal characteristics, clarify your development goals and discuss your career development path with a more clear and sharp perspective, so that you can organise and present a better version of yourself on your CV, in interviews and within organisations more effectively",
    industry2: "Click on the industry you are interested in",
    moreService: "More Services",
    jobplan: "Career Sonsultation                \n",
    prodaoshi: "Professional Mentors PDP behavioral assessments analysis",
    prodaoshi2: "Provide job consultation service",
    prodaoshi3: "Resume Update",
    prodaoshi4: "Combining past experience with job search goals",
    prodaoshi6: "Create a resume that matches the professional position",
    prodaoshi7: "Written Test/Interview Coaching",
    prodaoshi8: "1V1 coaching in targeted industries",
    prodaoshi9: "Practical Simulation/FAQ",
    prodaoshi10: "Employment Opportunity Referral",
    prodaoshi11: "Provide one job opportunity",
    prodaoshi12: "Get an interview opportunity",
    prodaoshi15:
      "Services include resume writing and interview coaching will not be charged repeatedly",
    requirename: "Please enter your name",
    requiredegree: "Please enter your graduate institution",
    requirephone: "Please enter your contact information",
    requireemail: "Please enter your email address",
    requireremark: "Please specify your job selection requirements",
  },
  others: {
    benke: "Bachelor",
    shuoshi: "Master",
    boshi: "Doctor",
    inputname: "Please enter your Name",
    inputbiyeyuanxiao: "Graduate institution",
    inputcontactway: "Please enter your Contact Way",
    inputemail: "Please enter your email address",
    remark:
      "Job selection requirements (for example: desired city for work, industry, salary range, etc.)",
    remarkmsg:
      "Your information has been encrypted, please fill it in with confidence",
    submit: "Submit",
    email: "Email",
    contact: "Contact Way",
    name: "Name",
    serviceMoreWX: "Add UC-Elink the assistant‘s WeChat",
    serviceMoreMsg: "Learn more details",
    serviceMethod2:
      "Method 2: Please leave the following information, and one of our colleagues will proactively contact you to schedule a consultation time",
    serviceMethod1:
      "Method 1: Add the UC-ELINK assistant, and we will have a colleague to consult with you one-on-one",
    serviceMethod: "You have two ways to access our services",
    clicktoConsult: "Click to Consult",
    viemMore: "View More",
    returnbutton: "return",
    kouhao: "Connecting  top talents in China and the United Kingdom",
    shangwu: "Business Cooperation",
    zhaopin: "Recruitment and Job Seeking",
    latestjob: "Latest Job",
    moreconditon: "Selected Conditions",
    moreconditon2: "More Conditions",
    salaryrange: "Salary Range",
    worklocation: "Work Location",
    inputtext1:"Please enter keywords for search, such as job title",
    morecondition11:"Educational requirements",
    morecondition12:"Work Experience",
    morecondition13:"Enterprise Ownership",
    morecondition14:"Company Size",
  },
  menus: {
    product: "Products & Services",
    product1: "Talents Recruitment",
    product2: "Tailor-made Bussiness Visits",
    product3: "Summer Camps",
    product4: "Job Fairs",
    jobpulish: "Find a Job",
    aboutus: "About UC-Elink",
    ourmission: "Our Mission",
    contactus: "Contact Us",
    aiRecommendation: "AI Recommendation",
    founderProfile: "About the Founder",
    onebyguide: "One-on-one Career Guidance",
    selectjob: "Career Consultation",
    talentservices:"Talent Services",
    advertisement:"Advertising",
    consultingService:"Consulting",
    activity:"Offline Events",
    companynews:"Company News",
    businessCo:"Business Cooperation",
    jobseeker:"Recruitment and Job Seeking",
  },
  joblist: {
    jobdes: "Job Description",
    jobname: "Job Title",
    joblocation: "Work Location",
    jobnum: "Recruiting Number",
    jobexprence: "Work Experience",
    jobxueli: "Educational Requirements",
    jobhangye: "Types of Industry",
    jobxingzhi: "Nature of the Company",
    jobguimo: "Company Scale",
    jobcompanyname: "Company Name",
    jobsalary: "Salary",
    jobdescription: "Position Description",
    application: "Fill in the application",
    name: "Full Name",
    lastname: "Last Name",
    phone: "Phone Number",
    email: "Email",
    message: "Leave a Message～",
    attachment: "Attachment",
    selectfile: "Upload Your Resume",
    inputname: "Please input your First Name",
    inputlastname: "Please input your Last Name",
    inputphone: "Please input your Phone Number",
    inputemail: "Please input your Email",
    description:
      "Supported formats: .doc, .docx, .pdf; individual file size limit: 50MB",
    apply: "Submit Application",
    return: "Return",
    success: "Submission Successful",
    successmsg:
      "Thank you for your submission, we will contact you within 5 working days if there is any feedback.",
    successmsg1:
      "Thank you for your application, we will contact you within 1 working day",
  },
  aiRecommendation: {
    selfIntroduction: "Self-Introduction",
    jobRecommendation: "AI job recommendation",
    message:
      "The AI job recommendation feature analyse your self-introduction and recommend the most suitable positions for you. Please describe yourself in the input box below, including your major, work experiences, skills, and career goals.",
    helpMeToRecommend: "Recommend for me",
    thefollowingisjob:"Here are the job positions recommended for you:",
    zhiyeyoushi:"Identify your career strengths.",
    dataIsLoading: "Data Analysis Loading",
    pleaseInputContent:
      "Please key in your self introduction, 50 - 1000 characters.",
    resultMessage: "The following are the recommended positions for you:", // "经过分析，以下是为您推荐的职位："
    moreJobs: "More Jobs >>",
    retry: "Retry",
    guanzhuren: "People-Oriented",
    guanzhuwu: "Task-Oriented",
    juxiang: "Concrete",
    chouxiang: "Abstract",
    guanzhurenmiaoshu: "Making decisions based on personal feelings and values.",
    guanzhuwumiaoshu: "Making decisions based on facts and logical analysis.",
    juxiangmiaoshu: "Focuses on practicality and applicability, aiming to achieve goals.Knowledge comes from practice.",
    chouxiangmiaoshu: "Focuses on concepts and theories, understanding things through ideas.Explores the essence of things.", 
  },
  founderFile: {
    founder: "Founder and CEO of UC-Elink",
    previousPosition: "Previous Positions",
    previousExperience1: "General Manager of HRoot",
    previousExperience2: "Founder of vTradex",
    previousExperience3:
      "Vice President of China Europe Human Resources Research Association",
    previousExperience4:
      "Executive Coach of China Europe International Business School (CEIBS) Leadership Development Center",
    previousExperience5: "General Manager of PDP China",
    previousExperience6: "National Sales Director of NetEase",
    previousExperience7:
      "Sales and Customer Service Director of Dun & Bradstreet",
    persondescrible1:
      "Mr. Kevin Qian has held executive positions in foreign enterprises, state-owned enterprises, and private enterprises, and he also has extensive entrepreneurial experience. Founded vTradex in 2001,under his leadership has become one of the largest domestic logistics software and solutions providers in China.He has deep insights and practical experience in the operation management and marketing strategies of companies at different stages of development and nature. Mr. Qian has long been engaged in marketing and management work, possessing rich experience in marketing and managing various types of products.",
    persondescrible2:
      "Kevin Qian is an EMBA from China Europe International Business School (CEIBS)  ,Class of 2008.",
    onebyguidedescrible:
      "Through the understanding of graduates' majors, grades, personalities, city preferences and interests, we suggest suitable career directions, provide guidance on CV preparation and interview skills.Match graduates with high-quality companies and corresponding positions, significantly enhancing graduates' employment success rates.For inquiries, please contact: ",
  },
  webcontents:{
    adervertise:"Content Creation、Graphic Design、Digital Advertising & Promotion",
    consulting:"CExecutive Talent Resources、Business Management and Development、Market Research",
    onlineservices:"Business Visits、Business Events & Functions、Campus Recruitment、Talent Training Programs",
  },
  news:{
    latestnew:"Latest News",
    morenews:"More News",
  },
};

const zh = {
  productservice: {
    product: "产品及服务",
    people: "高端人才选拔和推荐",
    forclient: "为客户推荐英国高校本科、硕士、博士等高端人才",
    gongwu: "公务考察定制化解决方案",
    school: "中小学夏校",
    corporation: "和英国知名中小学合作，提供在英国的各类夏校和夏令营",
    onoffline: "线上线下招聘会",
    zhanlue: "战略合作伙伴",
  },
  aboutus: {
    info1:
      "致力于链接中英顶尖人才。作为一个立足英国全球拓展的人才综合平台,专注为全球顶尖人才提供专业、高效的职业规划咨询及名企推荐服务。",
    info2:
      "UC-Elink优势人才核心团队具有十多年人力资源行业服务,人才选聘,媒体经验和二十年企业管理经验。成员均有多年知名企业工作和海外求学背景,深刻理解海外人才群体特点,对企业海外人才需求见解独到。愿意与各位中英人才携手,共同应对全球化进程带来的机遇与挑战,助力优秀人才实现职业发展的全球化梦想。",
    info3:"",
    info4:"",
    info5:"",
    ourservice: "我们的服务",
    ourserviceinfo:
      "在中英两国拥有大量高端企业客户、有覆盖全英高校的网络、具备举办线上线下大型招聘活动和商务考察经验。",
    ourservice1: "高端人才选拔和推荐",
    ourservice2: "为客户推荐英国高校本科、硕士博士等高端人才。",
    ourservice3: "公务考察整体解决方案",
    ourservice4: "中小学夏校",
    ourservice5: "和英国知名中小学合作，提供在英国的各类夏校和夏令营",
    ourservice6: "线上线下招聘会",
    founder1: "创 始 人",
    founder2: "钱   峰",
    founder3: "中欧国际工商管理学院EMBA",
    founder4: "中欧人力资源研究会 副会长",
    founder5: "曾任",
    founder6: "HRoot 总经理",
    founder7: "唯智信息(vTradex)创始人",
    founder8: "PDP中国总经理",
    founder9: "网易全国销售总监",
    contactinfo1: "致力于链接中英顶尖人才",
    contactinfo2: "联系我们即可获得专属职业规划咨询!",
    contactinfo3: "联系我们",
    contactinfo4: "战略合作伙伴",
    common1: "隐私政策",
    common2: "联系我们",
    common3: "关于我们",
    common4: "保留所有权利",
    team:
      "核心团队具有十多年人力资源行业服务、人才选聘、媒体经验和二十年企业管理经验",
    client: "在中英两国拥有大量高端企业客户",
    network: "有覆盖全英高校的网络",
    onoffline: "具备举办线上线下大型招聘活动和商务考察经验",
  },
  consultant: {
    zhitongche: "择业直通车-助您顺利获得理想工作",
    zhitongche1: "量身定制个性化求职解决方案，大幅提升就职成功率",
    zhitongche2: "可携简历添加咨询求职顾问,了解详情",
    industry: "选择您感兴趣的行业",
    industry1:
      "我们将以更加清醒犀利的视角，帮您梳理个人特点、明确发展目标,共同探讨职业发展路径,为您更有效在简历上、面试中以及组织内部,整理和呈现更好的自己。",
    industry2: "点击你感兴趣的行业",
    moreService: "更多服务",
    jobplan: "职业规划咨询",
    prodaoshi: "专业导师PDP性格测评分析",
    prodaoshi2: "提供相应求职规划咨询",
    prodaoshi3: "简历精修",
    prodaoshi4: "结合求职目标梳理过往经历",
    prodaoshi6: "打造符合专业岗位的简历",
    prodaoshi7: "笔/面试辅导",
    prodaoshi8: "目标行业1V1辅导",
    prodaoshi9: "实战模拟/常见问题",
    prodaoshi10: "就业机会推荐",
    prodaoshi11: "提供一次就业机会",
    prodaoshi12: "获得面试机会",
    prodaoshi15: "上述简历编写和面试辅导费用，将不再重复收取",
    requirename: "请输入姓名",
    requiredegree: "请输入毕业院校",
    requirephone: "请输入联系方式",
    requireemail: "请输入邮箱",
    requireremark: "请填写择业需求",
  },
  others: {
    benke: "本科",
    shuoshi: "硕士",
    boshi: "博士",
    inputname: "请输入姓名",
    inputbiyeyuanxiao: "请输入毕业院校",
    inputcontactway: "请输入联系方式",
    inputemail: "请输入邮箱",
    remark: "择业需求（比如：期望工作的城市，行业，薪资范围等）",
    remarkmsg: "您的信息已加密，请放心填写",
    submit: "提交",
    email: "邮箱",
    contact: "联系方式",
    name: "姓名",
    serviceMoreWX: "添加UC-Elink小助手微信",
    serviceMoreMsg: "了解更多详情",
    serviceMethod2: "途径2:请留下以下信息,我们会有同事主动联系您预约咨询时间",
    serviceMethod1: "途径1:添加UC-ELINK小助手，我们会有同事和您一对一咨询",
    serviceMethod: "您有两种途径获得我们的服务",
    clicktoConsult: "点击咨询",
    viemMore: "查看更多",
    returnbutton: "返回",
    kouhao: "链接中英顶尖人才",
    shangwu: "商务合作",
    zhaopin: "招聘求职",
    latestjob: "最新职位发布",
    moreconditon:"已选条件：",
    moreconditon2:"更多条件",
    salaryrange: "薪资范围",
    worklocation: "工作地点",
    inputtext1:"请输入关键词进行搜索，如职位名称",
    morecondition11:"学历要求",
    morecondition12:"工作经验",
    morecondition13:"公司性质",
    morecondition14:"公司规模",
  },
  menus: {
    product: "产品及服务",
    product1: "高端人才选拔和推荐",
    product2: "公务考察定制化解决方案",
    product3: "中小学夏校",
    product4: "线上线下招聘会",
    jobpulish: "职位发布",
    aboutus: "关于我们",
    ourmission: "我们的使命",
    contactus: "联系我们",
    aiRecommendation: "AI 求职",
    founderProfile: "创始人简介",
    onebyguide: "一对一择业指导",
    selectjob: "择业咨询",
    talentservices:"人才服务",
    advertisement:"广告",
    consultingService:"咨询",
    activity:"线下活动",
    companynews:"公司新闻",
    businessCo:"商务合作",
    jobseeker:"招聘求职",
  },
  joblist: {
    jobdes: "职位信息",
    jobname: "职位名称",
    joblocation: "工作地点",
    jobnum: "招聘人数",
    jobexprence: "工作经验",
    jobxueli: "学历要求",
    jobhangye: "所属行业",
    jobxingzhi: "公司性质",
    jobguimo: "公司规模",
    jobcompanyname: "公司名称",
    jobsalary: "工作薪资",
    jobdescription: "职位描述",
    application: "填写申请",
    name: "姓",
    lastname: "名",
    phone: "手机",
    email: "邮箱",
    message: "留言",
    attachment: "附件",
    selectfile: "上传简历",
    inputname: "请输入姓",
    inputlastname: "请输入名",
    inputphone: "请输入手机号码",
    inputemail: "请输入正确的邮箱地址",
    description: "支持格式：.doc .docx .pdf ，单个文件不能超过50MB",
    apply: "提交申请",
    return: "返回",
    success: "提交成功",
    successmsg: "感谢你的投递，如果有反馈，我们会在5个工作日内联系您",
    successmsg1: "感谢你的申请，我们会在1个工作日内联系您",
  },
  aiRecommendation: {
    selfIntroduction: "自我介绍",
    jobRecommendation: "智能职位推荐",
    message:
      "智能职位推荐功能将根据您输入的自我介绍，经由人工智能精确分析，并为您推荐最贴合的职位。现在，请在下方的输入框中详细描述您的个人情况，包括所学专业、丰富的实习经历、独特的技能优势以及个人喜好和职业目标。",
    helpMeToRecommend: "帮我推荐",
    thefollowingisjob:"以下是为您推荐的职位:",
    zhiyeyoushi:"测出自己的职业优势",
    dataIsLoading: "数据分析中",
    pleaseInputContent: "请输入您的自我简介, 50 - 1000 字符.",
    resultMessage: "经过分析，以下是为您推荐的职位：",
    moreJobs: "更多职位 >>",
    retry: "重新输入",
    guanzhuren: "关注人",
    guanzhuwu: "关注物",
    juxiang: "具象",
    chouxiang: "抽象",
    guanzhurenmiaoshu: "根据个人的感受和价值观对生活，人与事作出重要决策",
    guanzhuwumiaoshu: "根据事实依据和逻辑分析对生活，人与事作出重要决策",
    juxiangmiaoshu: "注重实效和应用性，以达成目标为原则。实践才能出真知",
    chouxiangmiaoshu: "注重概念和理论性，依据概念理解事物。探索事物的本质", 
  },
  founderFile: {
    founder: "UC-Elink创始人兼CEO",
    previousPosition: "曾任",
    previousExperience1: "HRoot总经理",
    previousExperience2: "唯智信息（vTradex）创始人",
    previousExperience3: "中欧人力资源研究会 副会长",
    previousExperience4: "中欧国际工商学院领导力发展中心 高管教练",
    previousExperience5: "PDP中国总经理",
    previousExperience6: "网易全国销售总监",
    previousExperience7: "Dun & Bradstreet销售及客户服务总监",
    persondescrible1:
      "钱峰先生不仅在外企，国企、民企均担任过高管，还有着丰富的创业经历。他于2001年创立的唯智信息目前已成为国内规模最大的物流软件及解决方案供应商之一。他对于不同发展阶段与性质的公司的运营、管理以及营销策略有着深刻的见解与实践经验。钱先生长期从事市场营销和管理方面工作，有丰富的不同类型产品的营销经验和管理经验。",
    persondescrible2: "钱峰先生为中欧国际工商管理学院2008级EMBA。",
    onebyguidedescrible:
      "通过对于毕业生专业、成绩、个性、城市选择以及兴趣爱好等多方面的了解，建议合适的择业方向，给予简历准备、面试技巧等方面的指导，对接优质的企业和相应职务，大大提升毕业生的就业成功率。详情请咨询:",
  },
  webcontents:{
    adervertise:"内容创意、平面设计、平台发布",
    consulting:"人才市场、企业管理及商业拓展方面的咨询及市场调研",
    onlineservices:"商务考察、校招、培训、商务活动",
  },
  news:{
    latestnew:"最新新闻",
    morenews:"更多新闻",
  },
};

// 4、创建 VueI18n 实例，并为 messages 和 locale 属性赋值
const i18n = new VueI18n({
  messages: {
    zh,
    en,
  },
  locale: "zh",
});

import echarts from "echarts";
Vue.prototype.$echarts = echarts;

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);

import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
Vue.use(VideoPlayer);

import "./assets/iconfont/iconfont.css";
import "./assets/css/style.css";

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require("./assets/img/error.png"),
  //加载时显示的GIF图
  loading: require("./assets/img/loading.gif"),
  //尝试加载几次
  attempt: 1,
});

import VueParticles from "./vue-particles";
Vue.use(VueParticles);

Vue.config.productionTip = false;

//设置超时时间
axios.defaults.timeout = 15000;
//设置api地址
//全局定义axios
axios.defaults.baseURL = "https://www.uk-elink.com:8082/api/";
//axios.defaults.baseURL = 'http://localhost:6879/api/'
Vue.prototype.$http = axios;

// 图片服务器地址
Vue.prototype.imgserver = "http://shkjgw.shkjem.com/";

new Vue({
  i18n,
  router,
  render: (h) => h(App),
}).$mount("#app");
